import { createAction } from "@reduxjs/toolkit";

export const getSymptomsSuccess = createAction('symptoms/getSuccess')
export const getSymptomsError = createAction('symptoms/getError')
export const getSymptomsRequest = createAction('symptoms/getSymptomsRequest')